import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonsModule, CardModule, RadioButtonModule } from 'axis-components';
import { RequestService } from '../../../_services/request/request.service';
import { InsuredMainService } from '../../../_services/uim-ui/insured-main.service';
import { FormType, RequestProgressStep } from '../../../config/constants';
import { AnalyticsService } from '../../../_shared/analytics/analytics.service';
@Component({
  standalone: true,
  selector: 'app-uimui-consent',
  templateUrl: './uimui-consent.component.html',
  styleUrls: ['./uimui-consent.component.scss'],
  imports: [CardModule, RadioButtonModule, ButtonsModule],
})
export class UimuiConsentComponent implements OnInit {
  constructor(
    private readonly insuredMainService: InsuredMainService,
    private router: Router,
    private requestService: RequestService,
    private analyticsService: AnalyticsService,
  ) {}

  disclosure: any;
  selectedOptionType: string = '';
  @Input() ctaData: any = {};
  @Input() formObj: any = {};
  @Output() selectionMade = new EventEmitter<string>();

  ngOnInit(): void {
    this.insuredMainService.getDisclosureData().subscribe((data) => {
      this.disclosure = data;
    });
    this.goTop();
  }
  goTop(): void {
    // reset the page when changing route
    window.scrollTo(0, 0);
  }

  onSelection(type: string): void {
    this.selectedOptionType = type;
    this.selectionMade.emit(type);
  }

  onContinue(): void {
    // Refresh request state so start logic uses the latest DB step.
    this.requestService.refreshRequestData(false).subscribe({
      next: () => this.handleContinueWithFreshStep(),
      // Fall back to cached state if the refresh call fails.
      error: () => this.handleContinueWithFreshStep(),
    });
  }

  private handleContinueWithFreshStep(): void {
    // Read current DB-backed step snapshot before moving the form ahead.
    const currentFormStep = this.requestService.getStepForFormType(
      FormType.UM_UIM,
    );
    const isUimuiCompleted = this.requestService.isFormTypeAlreadyCompleted(
      FormType.UM_UIM,
    );

    // If UM/UIM is already completed, do not continue with consent routing.
    if (isUimuiCompleted) {
      return;
    }

    // Emit start only if this request has not started UM/UIM yet.
    const shouldEmitFormStart =
      (!currentFormStep || currentFormStep.includes('Not Started')) &&
      !this.analyticsService.formStartUmSet;

    if (shouldEmitFormStart) {
      this.analyticsService.formStartUmSet = true;
    }

    this.requestService.updateRequestProgress(
      FormType.UM_UIM,
      RequestProgressStep.DIGITAL_SIGNATURE_CONSENT,
      {},
    );

    // Get current origin like analytics directive
    const baseUrl = window.location.origin;

    if (this.selectedOptionType === 'rejected') {
      const targetRoute = '/insured/uimui-non-digital';
      this.ctaData.ctaName = 'DigiSign:um_uim:consent:rejected:continue';
      this.ctaData.ctaUrl = `${baseUrl}${targetRoute}`;
      this.analyticsService.setAdobeDataLayerCTAEvent(this.ctaData);

      // Build formStart payload for the non-digital landing route.
      const originalPageName = 'DigiSign:um_uim:nonDigital';
      this.formObj.page = {
        ...this.formObj.page,
        pageName: originalPageName,
        URL: `${baseUrl}${targetRoute}`,
        fullURL: `${baseUrl}${targetRoute}`,
        previousURL: `${baseUrl}${window.location.pathname}`,
      };

      const currentStep = this.analyticsService.getStepFromUrl(
        `${baseUrl}${targetRoute}`,
        originalPageName,
      );
      this.formObj.event = 'formStart';
      // Emit start once even when the user begins through rejected consent path.
      if (shouldEmitFormStart) {
        this.analyticsService.setAdobeDataLayer(this.formObj, currentStep);
      }

      this.router.navigate([targetRoute], {
        queryParamsHandling: 'preserve',
      });
    } else {
      const targetRoute = '/insured/uimui-selection';
      this.ctaData.ctaName = 'DigiSign:um_uim:consent:continue';
      this.ctaData.ctaUrl = `${baseUrl}${targetRoute}`;
      this.analyticsService.setAdobeDataLayerCTAEvent(this.ctaData);

      // Set page URL information in formObj for the target route
      const originalPageName = 'DigiSign:um_uim:selectionCoverages';

      this.formObj.page = {
        ...this.formObj.page,
        pageName: originalPageName,
        URL: `${baseUrl}${targetRoute}`,
        fullURL: `${baseUrl}${targetRoute}`,
        previousURL: `${baseUrl}${window.location.pathname}`,
      };

      const currentStep = this.analyticsService.getStepFromUrl(
        `${baseUrl}${targetRoute}`,
        originalPageName,
      );
      this.formObj.event = 'formStart';
      // Emit start once when the user starts from the selection path.
      if (shouldEmitFormStart) {
        this.analyticsService.setAdobeDataLayer(this.formObj, currentStep);
      }
      this.router.navigate([targetRoute], {
        queryParamsHandling: 'preserve',
      });
    }
  }
}
